<template lang="pug">
.v-product.product(v-if="product"
		:class="{'product--sm': size === 'sm', 'product--alt-mob': altMob}")
	template(v-if="template === 'grid'")
		template(v-if="isXs && altMob && product.images && product.images.length")
			component.product__slider-wrap(:is="altMob && isSm ? 'a' : 'div'" :href="product.link")
				v-swiper-slider.product__slider(:options="options")
					swiper-slide.product__slide(v-for="(image, imageIndex) in product.images" :key="imageIndex")
						img.product__slide-image(:src="image.medium" alt=""
							:class="{'product__image--visible': imageIndex === activeImageIndex}" loading="lazy")
					template(v-if="product.videos && product.videos.length")
						swiper-slide.product__slide(v-for="(video, videoIndex) in product.videos" :key="videoIndex")
							v-video.product__video(:src="video.src"
									:type="video.type"
									:autoplay="video.autoplay"
									:muted="video.muted"
									linked="true"
									:poster="video.poster")
					template(v-if="product.actions")
						swiper-slide.product__slide.product__slide--narrow(v-if="product.actions.call")
							.product__mob-action.product__mob-action--yellow(@click="openFormCall")
								v-svg-icon.product__mob-action-icon(icon="call")
								.product__mob-action-text.flc {{product.actions.call.text}}
						swiper-slide.product__slide.product__slide--narrow(v-if="product.actions.chat")
							.product__mob-action.product__mob-action--black
								v-svg-icon.product__mob-action-icon(icon="chat")
								.product__mob-action-text.flc {{product.actions.chat.text}}
						swiper-slide.product__slide.product__slide--narrow(v-if="product.actions.map")
							.product__mob-action.product__mob-action--magenta
								v-svg-icon.product__mob-action-icon(icon="map")
								.product__mob-action-text.flc {{product.actions.map.text}}
								.product__mob-action-note.flc {{product.actions.map.note}}
				.product__labels(v-if="product.label || product.label2")
					.product__label.flc(v-if="product.label") {{product.label}}
					.product__label-2.flc(v-if="product.label2") {{product.label2}}
		a.product__visual(v-if="isXs ? !altMob : true" :href="product.link")
			.product__images(v-if="product.images && product.images.length"
					:class="{'product__images--dark': activeImageIndex === 4 && product.imageCount > 5}")
				template(v-for="(image, imageIndex) in product.images" :key="imageIndex")
					template(v-if="imageIndex <= 5")
						img.product__image(v-if="imageIndex === 0 ? true : isPicturesLoaded"
								:class="{'product__image--visible': imageIndex === activeImageIndex}"
								:src="imageIndex === 0 ? image.medium : (isPicturesLoaded ? image.medium : null)"
								alt=""
								loading="lazy")
						v-loader.product__image-loader(:loading="imageLoading")
				.product__more-photo(v-if="product.imageCount > 5"
						:class="{'product__more-photo--visible': activeImageIndex === 4}")
					v-svg-icon.product__more-photo-icon(icon="camera")
					.product__more-photo-text Eще {{product.imageCount - 5}} фото
			.product__controls(v-if="product.images && product.images.length"
					@mouseenter="imageLoading = true; isPicturesLoaded = true"
					@mouseleave="activeImageIndex = 0; imageLoading = false")
				template(v-for="(control, imageIndex) in product.images" :key="imageIndex")
					template(v-if="imageIndex < 5")
						.product__control(@mouseenter="activeImageIndex = imageIndex")
			.product__labels(v-if="product.label || product.label2")
				.product__label.flc(v-if="product.label") {{product.label}}
				.product__label-2.flc(v-if="product.label2") {{product.label2}}
		.product__main
			.product__favorite-action(v-if="isXs && altMob")
				v-favorite-action(:id="product.id" :name="product.name" :model="product.model")
			a.product__name(v-if="product.name"
					:href="product.link")
				| {{product.name}}
				img.product__top(v-if="product.isTop" :src="topImage" alt="" loading="lazy")
			.product__description(v-if="product.description") {{product.description}}
			// Цена в ...
			.product__prices(v-if="product.price")
				.product__price.flc(v-if="product.price")
					v-price(:price="product.price" @open-details="openDetails" :stop-propagation="true")
				// Лизинг / кредит на дэсктопе
				.product__price.flc(v-if="!isSm && !product.tradingForecast && product.payment")
					.price__title(v-if="product.paymentText") {{product.paymentText}}
					.product__payment(v-if="product.payment")
						.product-payment
							v-svg-icon.product-payment__icon(icon="payment")
							.product-payment__text {{product.payment}}
			.product__prices(v-if="product.rate || product.tradingForecast")
				// Текущая ставка
				template(v-if="isSm && product.tradingForecast && product.rate && product.rate?.current?.value === 1 ? false : product.rate")
					.product__price.flc(v-if="product.rate")
						v-price(:price="product.rate" view="rate" size="sm")
				// Прогноз торгов
				.product__price.flc(v-if="product.tradingForecast")
					v-price(:price="product.tradingForecast" size="sm")
				// Лизинг / кредит на дэсктопе
				.product__price.flc(v-if="!isSm && !product.tradingForecast && product.payment")
					.price__title(v-if="product.paymentText") {{product.paymentText}}
					.product__payment(v-if="product.payment")
						.product-payment
							v-svg-icon.product-payment__icon(icon="payment")
							.product-payment__text {{product.payment}}
			// С доставкой
			.product__prices.product__prices--delivery(v-if="product.deliveryPrice")
				.product__price.flc
					v-price(:price="product.deliveryPrice" view="delivery" @open-details="openDetails")
			// Лизинг / кредит на моб
			.product__price.flc(v-if="isSm && !product.tradingForecast && product.payment")
				.price__title(v-if="product.paymentText") {{product.paymentText}}
				.product__payment(v-if="product.payment")
					.product-payment
						v-svg-icon.product-payment__icon(icon="payment")
						.product-payment__text {{product.payment}}
		.product__payment(v-if="!product.rate && !product.price && product.payment")
			.product-payment
				v-svg-icon.product-payment__icon(icon="payment")
				.product-payment__text {{product.payment}}
		// product__payment--bottom
		.product__price.product__price--bottom(v-if="product.tradingForecast && product.paymentText")
			.price__title {{product.paymentText}}
			.product__payment.product__payment--bottom
				.product-payment
					v-svg-icon.product-payment__icon(icon="payment")
					.product-payment__text {{product.payment}}
			//.product__action.flc
				//v-basket-action(:id="product.id")
		//-.product__action(v-if="isXs && altMob")
		//-	.product__action-wide
		//-		button.product__action-btn.btn.btn--primary.btn--block(@click="makeBet") Сделать ставку
		//-	.product__action-narrow
		//-		a.product__action-btn.btn(:href="product.link") Подробнее
		//-.product__action(v-if="isXs && altMob")
		//-	.product__action-wide
		//-		button.product__action-btn.btn.btn--primary.btn--block(@click="contact") Связаться
		//-	.product__action-narrow
		//-		a.product__action-btn.btn(@href="product.link") Подробнее
</template>

<script>
import controller from '../scripts/controller/controller';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import {SwiperSlide} from 'swiper/vue';

export default {
	mixins: [
		isMobMixin
	],

	props: {
		product: {
			type: Object,
			default: null
		},

		template: {
			type: String,
			default: 'grid'
		},

		size: {
			type: String,
			default: null
		},

		altMob: {
			type: Boolean,
			default: false
		},

		formContact: {
			type: String,
			default: null
		},

		formCall: {
			type: String,
			default: null
		},

		media: {
			type: Object,
			default: null
		},

		phones: {
			type: Object,
			default: null
		}
	},

	emits: [
		'delete-product'
	],

	components: {
		SwiperSlide
	},

	data() {
		return {
			activeImageIndex: 0,
			options: {
				slidesPerView: 'auto',
				spaceBetween: 3
			},
			topImage: "/local/assets/images/top.png",
			isPicturesLoaded: false,
			imageLoading: false
		};
	},

	computed: {
		computedDescription() {
			const description = [];
			if (this.product.year) {
				description.push(this.product.year);
			}
			if (this.product.mileage) {
				description.push(this.product.mileage);
			}
			if (this.product.shortEngineVolume) {
				description.push(this.product.shortEngineVolume);
			}
			if (this.product.driveType) {
				description.push(this.product.driveType);
			}
			return description.join(', ');
		},
	},

	methods: {
		openFormCall(e) {
			e.stopPropagation();
			controller.openModal({
				className: 'modal--sm',
				component: {
					name: 'v-form',
					props: {
						dataSource: {
							"success": false,
						},
						phones: this.phones,
						className: 'call-back'
					}
				}
			});
		},

		contact(e) {
			e.stopPropagation();
			controller.openModal({
				className: 'modal--sm',
				component: {
					name: 'v-form',
					props: {
						dataSource: this.formContact,
						media: this.media,
						phones: this.phones,
						className: 'call-back'
					}
				}
			});
		},

		makeBet(e) {
			e.stopPropagation();
			console.log('makeBet');
		},

		deleteBasketItem() {
			this.$emit('delete-product', this.product.id);
		},

		openDetails(e) {
			e.preventDefault();
			let priceValue = 0;
			let priceCustomsValue = 0;
			if (this.product.price && this.product.price.second && this.product.price.second.value) {
				priceValue = this.product.price.second.value;
			}
			if (this.product.priceCustoms && this.product.priceCustoms.second && this.product.priceCustoms.second.value) {
				priceCustomsValue = this.product.priceCustoms.second.value;
			} else if (this.product.rate && this.product.rate.current && this.product.rate.current.value) {
				priceCustomsValue = this.product.rate.current.value;
			}
			if (this.product.rate && this.product.rate.current) {
				priceValue = this.product.rate.current.value;
			}

			let productData = {
				id: this.product.id,
				price: priceValue,
				priceCustoms: priceCustomsValue,
				options: this.product.options,
				addOptions: this.product.addOptions,
				total: this.product.total,
				year: this.product.year,
				customsCalculator: this.product.customsCalculator,
				engineType: this.product.engineType,
				engineVolume: this.product.engineVolume,
				bid: this.product.bid,
				auctionType: this.product.auctionType,
				stateDelivery: this.product.stateDelivery,
				lemonService: this.product.lemonService,
				enginePower: this.product.enginePower,
				carAge: this.product.carAge,
				carEngine: this.product.carEngine,
				benefit: this.product.benefit,
				country: this.product.country,
				currency: this.product.currency,
			};
			console.log('product', this.product);
			// console.log('openDetails productData', productData);
			controller.openModal({
				className: 'modal--sm',
				//historyUrl: this.product.link,
				component: {
					name: 'v-details',
					props: {
						propProductData: productData,
						withoutBackArrow: this.product.formDetails ? null : true,
						view: this.product.formDetails ? "regular" : "customs-calculator",
						dataSource: this.product.formDetails || this.product.customsCalculator
					}
				}
			});
		}
	}
};
</script>